import Header from "./components/Header";
import SliderSingle from "./blocks/slider_single";
import SliderMulti from "./blocks/slider_multi";
import Video from "./blocks/video";
import Accordion from "./blocks/accordion";
import Form from "./components/Form";
import Select from "./components/Select";
import Map from "./blocks/map";
import Listing from "./blocks/listing";
import AnimatedBgdText from "./components/animatedBgdText";
import HeroHome from "./blocks/heroHome"
import ImageResize from "./components/imageResize"
import Leadership from "./blocks/leadership";
import Newsletter from "./blocks/newsletter";
import Password from "./blocks/password";


const main = {
    init: function() {
        Header.init();
        SliderSingle.init();
        SliderMulti.init();
        Video.init();
        Accordion.init();
        Select.init();
        //Form.init();
        Newsletter.init();
        Map.init();
        Leadership.init(); //mettre avant listing
        Listing.init(Leadership.resize);
        AnimatedBgdText.init();
        HeroHome.init();
        ImageResize.init();
        Leadership.init();
        Password.init();
    }
};

export default main